<template lang="html">
  <div class="subject">
    <div class="content" v-if='code >= 0'>
      <div v-for="a in subjectList" :key="a.id" class="subjectList">
        <!-- 论坛帖 -->
        <div v-if="a.object_type == 1" @click="goForum(a.topicid)">
          <div class="userHeader">
            <div class="userInfo">
              <div class="userImg">
                <img :src="a.avatar" alt="" class="userHeadPortrait">
                <img src="@/assets/image/icon/pv.png" alt="" class="userMark" >
              </div>
              <div class="userName">
                <p>{{a.author}}</p>
              </div>
            </div>
            <p class="stick" v-show="a.is_recommend">置顶</p>
          </div>
          
          <!-- 一张图 -->
          <div v-if="a.thread_pics.length == 1" class="forumContentNo1">
            <p class="forumTitle">{{a.title}}</p>
            <div>
              <img :src="a.thread_pics[0]" alt="">
              <p class="forumDescribe">{{a.content}}</p>
            </div>
          </div>
          <!-- 两三张图 -->
          <div v-else-if="a.thread_pics.length >= 2" class="forumContentNo2">
            <p class="forumTitle">{{a.title}}</p>
            <p class="forumDescribeNo" v-show="a.content">{{a.content}}</p>
            <div class="forumImg">
              <img v-for="(b, index) in a.thread_pics.slice(0, 3)" :key="index" :src="b" alt="">
            </div>
          </div>
          <!-- 无图 -->
          <div v-else class="forumContentNo3">
            <p class="forumTitle">{{a.title}}</p>
            <p class="forumDescribeNo">{{a.content}}</p>
          </div>
          
          <div class="hotModel">
            <div class="hotModelChild"><img src="@/assets/image/icon/browse.png" alt=""><span>{{a.views}}</span></div>
            <div class="hotModelChild"><img src="@/assets/image/icon/reply.png" alt=""><span>{{a.replies}}</span></div>
            <div class="hotModelChild"><img src="@/assets/image/icon/praise.png" alt=""><span>{{a.likes}}</span></div>
          </div>
        </div>
        
        <!-- 短视频 -->
        <div v-if="a.object_type == 8" @click="goVideo(a.unique_id)">
          <div class="videoTop">
            <div class="videoUserImg">
              <img :src="a.avatar" alt="" class="videoUserHeadPortrait">
              <img src="@/assets/image/icon/pv.png" alt="" class="videoUserMark">
            </div>
            <p class="videoUserName"> {{a.username}} </p>
          </div>
          
          <p class="videoTitle">{{a.title}}</p>
          
          <div class="videoImg">
            <img :src="a.pic" alt="" class="videoPic">
            <img src="@/assets/image/icon/playBtn.png" alt="" class="videoPlay">
            <div class="videoStick" v-show="a.is_recommend"> 置顶 </div>
          </div>
          
          <div class="hotModel">
            <div class="hotModelChild"><img src="@/assets/image/icon/browse.png" alt=""><span>{{a.hitnum}}</span></div>
            <div class="hotModelChild"><img src="@/assets/image/icon/reply.png" alt=""><span>{{a.favoritenum}}</span></div>
            <div class="hotModelChild"><img src="@/assets/image/icon/praise.png" alt=""><span>{{a.likenum}}</span></div>
          </div>
        </div> 
        
        <!-- 话题贴 -->
        <div v-if="a.object_type == 9" @click="goTopicPost(a.postid)">
          <div class="userHeader">
            <div class="userInfo">
              <div class="userImg">
                <img :src="a.avatar" alt="" class="userHeadPortrait">
                <img src="@/assets/image/icon/pv.png" alt="" class="userMark" >
              </div>
              <div class="userName">
                <p>{{a.username}}</p>
                <div class="participation">
                  参与的话题
                </div>
              </div>
            </div>
            <p class="stick" v-show="a.is_recommend">置顶</p>
          </div>
          
          <!-- 一张图 -->
          <div v-if="a.images.length == 1" class="participationTopicNo1">
            <p class="topicTitle">{{a.title}}</p>
            <div>
              <p class="participationTopicDescribe">{{a.content}}</p>
              <img :src="a.images[0]" alt="">
            </div>
          </div>
          <!-- 两三张图 -->
          <div v-else-if="a.images.length == 2" class="participationTopicNo2">
            <p class="topicTitle">{{a.title}}</p>
            <p class="participationTopicDescribeNo" v-show="a.content">{{a.content}}</p>
            <div class="topicImg">
              <img v-for="(b, index) in a.thread_pics.slice(0, 3)" :key="index" :src="b" alt="">
            </div>
          </div>
          <!-- 无图 -->
          <div v-else class="participationTopicNo3">
            <p class="topicTitle">{{a.title}}</p>
            <p class="participationTopicDescribeNo">{{a.content}}</p>
          </div>
          
          <div class="hotModel">
            <div class="hotModelChild"><img src="@/assets/image/icon/browse.png" alt=""><span>{{a.view_number}}</span></div>
            <div class="hotModelChild"><img src="@/assets/image/icon/reply.png" alt=""><span>{{a.comment_number}}</span></div>
            <div class="hotModelChild"><img src="@/assets/image/icon/praise.png" alt=""><span>{{a.like_number}}</span></div>
          </div>
        </div>
        
        <!-- 话题 -->
        <div v-if="a.object_type == 11" @click="goTopic(a.id)">
          <div class="userHeader">
            <div class="userInfo">
              <div class="userImg">
                <img :src="a.avatar" alt="" class="userHeadPortrait">
                <img src="@/assets/image/icon/pv.png" alt="" class="userMark" >
              </div>
              <div class="userName">
                <p>{{a.username}}</p>
                <div class="userIssue">
                  发布的话题
                </div>
              </div>
            </div>
            <p class="stick" v-show="a.is_recommend">置顶</p>
          </div>
          
          <!-- 一张图 -->
          <div v-if="a.images.length == 1" class="topicNo1">
            <p class="topicDescribe">{{a.topic_name}}</p>
            <img :src="a.images[0]" alt="">
          </div>
          <!-- 两三张图 -->
          <div v-else-if="a.images.length == 2" class="topicNo2">
            <p class="topicDescribeNo">{{a.topic_name}}</p>
            <div class="topicImg">
              <img v-for="(b, index) in a.thread_pics.slice(0, 3)" :key="index" :src="b" alt="">
            </div>
          </div>
          <!-- 无图 -->
          <div v-else class="topicNo3">
            <p class="topicDescribeNo">{{a.topic_name}}</p>
          </div>
          
          <div class="hotModel">
            <div class="hotModelChild"><img src="@/assets/image/icon/iconNo2.png" alt=""><span>{{a.following_num}}</span></div>
            <div class="hotModelChild"><img src="@/assets/image/icon/iconNo1.png" alt=""><span>{{a.joinnumber}}</span></div>
          </div>
        </div>  
      </div>
    </div>
    
    <div class="noInfo" v-else>
      <div>
        <img :src="`${pagebase}/static/img/elecom/circle.png`" alt="">
      </div>
      <p>暂无内容哦~</p>
    </div>
  </div>
</template>

<script>
  import {pagebase} from '@/utils/http'
  
  export default {
    props: ['userId'],
    
    data() {
      return {
        code: '',
        subjectList: {},
        pagebase: pagebase,
      }
    },
    
    mounted() {
      this.init();
    },
    
    methods: {
      init() {
        this.getSubject();
      },
      
      getSubject() {
        this.$http({
          url: '/eleom/getUniversityResourcesData',
          method: 'get',
          params: {
            master_id: this.userId,
            type: 1,
            page: 1,
            limit: 20,
          }
        }).then(res => {
          this.code = res.code;
          if (res.code >= 0) {
            this.subjectList = res.data;
          }
        })
      },
      
      goForum(tid) {
        sessionStorage.setItem('cur', 5);
        this.$router.push({
          path: '/invitation',
          query: {
            tid: tid,
          }
        })
      },
      
      goVideo(tid) {
        sessionStorage.setItem('cur', 5);
        this.$router.push({
          path: '/cFilm',
          query: {
            type: 2,
            id: tid,
          }
        })
      },
      
      goTopicPost(tid) {
        sessionStorage.setItem('cur', 5);
        this.$router.push({
          path: '/topicPost',
          query: {
            tid: tid,
          }
        })
      },
      
      goTopic(tid){
        sessionStorage.setItem('cur', 5);
        this.$router.push({
          path: '/topic',
          query: {
            tid: tid,
          }
        })
      },
    }
  }
</script>

<style lang="css" scoped>
  .subjectList {
    box-sizing: border-box;
    margin-bottom: .8rem;
    background-color: #FFFFFF;
    padding: 1.5rem;
    position: relative;
    border-bottom: .05rem solid #EEEFF0;
  }
 
  .userHeader {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .userInfo {
    display: flex;
    align-items: center;
    color: #3F454B;
    font-size: 12px;
  }
  
  .userImg {
    position: relative;
  }
  
  .userHeadPortrait {
    width: 2.1rem;
    height: 2.1rem;
    border-radius: 50%;
  }
  
  .userMark {
    position: absolute;
    left: 1.2rem;
    bottom: 0;
    width: 1.2rem;
    height: 1.2rem;
  }
  
  .userName {
    display: flex;
    align-items: center;
  }
  
  .userName p {
    margin-left: .8rem;
    font-size: 1.4rem;
    color: #606972;
  }
  
  .participation {
    margin-left: 1rem;
    background-color: #F3F8F1;
    color: #5D9854;
    padding: .3rem .75rem;
    border-radius: .3rem;
    font-size: 1.2rem;
  }
  
  .userIssue {
    margin-left: 1rem;
    
    background-color: #F3F6FB;
    color: #6E7A93;
    padding: .3rem .75rem;
    border-radius: .3rem;
    font-size: 1.2rem;
  }
  
  .stick {
    width: 4.65rem;
    height: 2rem;
    line-height: 2rem;
    text-align: center;
    background-color: rgba(247, 68, 63, 0.6);
    color: #FFF;
    border-radius: .4rem;
    font-size: 1.2rem;
  }
  
  .titleModel {
    margin-top: .7rem;
  }
  
  .userTitle {
    font-size: 1.6rem;
    color: #333333;
    overflow: hidden;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }
  
  .titleModel div{
    margin-top: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .userContent {
    line-height: 2rem;
    font-size: 1.4rem;
    margin-top: 1rem;
    color: #777777;
    overflow: hidden;
    -webkit-line-clamp: 3;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }
  
  .titleModel img{
    width: 11.3rem;
    height: 7.1rem;
    margin-left: .8rem;
    border-radius: .5rem;
    object-fit: cover;
  }
  
  .elseTitleModel {
    margin-top: .7rem;
  }
  
  .hotModel {
    display: flex;
    justify-content: flex-end;
    margin-top: 1rem;
  }
  
  .hotModelChild {
    width: 6rem;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  
  .hotModelChild img {
    width: 1.9rem;
  }
  
  .hotModelChild span{
    font-size: 1.2rem;
    color: #C0C4CC;
    margin-left: .25rem;
  }
  
  /* 短视频 */
  .videoTop {
    display: flex;
    align-items: center;
  }
  
  .videoUserImg {
    position: relative;
  }
  
  .videoUserHeadPortrait {
    width: 3.4rem;
    height: 3.4rem;
    border-radius: 50%;
  }
  
  .videoUserMark {
    position: absolute;
    left: 2.2rem;
    bottom: 0;
    width: 1.2rem;
    height: 1.2rem;
  }
  
  .videoUserName {
    font-size: 1.5rem;
    margin-left: 1rem;
  }
  
  .videoTitle {
    margin-top: .75rem;
    overflow: hidden;
    -webkit-line-clamp: 1;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }
  
  .videoImg {
    position: relative;
  }
  
  .videoPic {
    width: 100%;
    height: 19.5rem;
    object-fit: cover;
    border-radius: .5rem;
    margin-top: .55rem;
  }
  
  .videoPlay {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 4.2rem;
    height: 4.2rem;
    margin-top: -2rem;
    margin-left: -2rem;
  }
  
  .videoStick {
    position: absolute;
    top: 1.55rem;
    right: 1rem;
    padding: .3rem 1.2rem;
    background-color: rgba(247, 68, 63, 0.6000);
    color: #FFF;
    border-radius: .4rem;
  }
  
  /* 论坛 */
  /* 一张图 */
  .forumContentNo1 div {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  
  .forumContentNo1 img {
    width: 11.3rem;
    height: 7.1rem;
  }
  
  .forumTitle {
    margin-top: .75rem;
    overflow: hidden;
    -webkit-line-clamp: 1;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }
  
  .forumDescribe {
    width: 22rem;
    color: #777777;
    font-size: 1.4rem;
    overflow: hidden;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }
  
  .forumImg {
    display: flex;
    margin-top: .75rem;
  }
  
  .forumImg img {
    width: 11.3rem;
    height: 7.1rem;
    object-fit: cover;
    border-radius: .5rem;
    margin-right: .3rem;
  }
  
  .forumContentNo3 {
    
  }
  
  .forumTitle {
    font-size: 1.6rem;
    color: #333333;
    overflow: hidden;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }
  
  .forumDescribeNo {
    margin-top: 1rem;
    font-size: 1.4rem;
    color: #777777;
    overflow: hidden;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }
  
  /* 话题贴 */
  .participationTopicNo1 div {
    margin-top: 1rem;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }
  
  .participationTopicNo1 img {
    width: 11.3rem;
    height: 7.1rem;
    border-radius: .5rem;
  }
  
  .participationTopicDescribe {
    width: 22rem;
    color: #777777;
    font-size: 1.4rem;
    overflow: hidden;
    -webkit-line-clamp: 3;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }
  
  .participationTopicDescribeNo {
    margin-top: 1rem;
    font-size: 1.4rem;
    color: #777777;
    overflow: hidden;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }
  
  .topicTitle {
    margin-top: .8rem;
    font-size: 1.6rem;
    color: #333333;
    overflow: hidden;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }
  
  .topicImg {
    display: flex;
    margin-top: .75rem;
  }
  
  .topicImg img {
    width: 11.3rem;
    height: 7.1rem;
    object-fit: cover;
    border-radius: .5rem;
    margin-right: .3rem;
  }
  
  /* 话题 */
  .topicNo1 {
    margin-top: 1rem;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }
  
  .topicNo1 img {
    width: 11.3rem;
    height: 7.1rem;
    border-radius: .5rem;
  }
  
  .topicDescribe {
    width: 22rem;
    color: #333333;
    font-size: 1.6rem;
    overflow: hidden;
    -webkit-line-clamp: 3;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }
  
  .topicDescribeNo {
    margin-top: 1rem;
    font-size: 1.6rem;
    color: #333333;
    overflow: hidden;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }
  
  /* 缺省页 */
  .noInfo {
    height: 37.5rem;
    background-color: #FFFFFF;
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
  }
  
  .noInfo img {
    width: 19.5rem;
    height: 19.5rem;
  }
  
  .noInfo p {
    font-size: 1.4rem;
    color: #9CA3A9;
  }
</style>